import { MDText } from 'i18n-react';

import { INFOBOX_VARIANT } from '@motorway/mw-highway-code/enums';
import type { ToastProps } from '@motorway/mw-highway-code/pre-alpha';

import texts from 'Components/DownloadCSV/DownloadCSV.texts';

import type { DownloadToastPollingState } from '../DownloadCSV.types';
import { DownloadToastType, PollingState } from '../DownloadCSV.types';

const T = new MDText(texts);

const defaultErrorProps = { persistent: false, status: DownloadToastType.Failed, variant: INFOBOX_VARIANT.ERROR };

const pollingStateLookup = {
	[PollingState.Error]: defaultErrorProps,
	[PollingState.RetriesLimitExceeded]: defaultErrorProps,
	[PollingState.AbortedFilter]: { ...defaultErrorProps, status: DownloadToastType.AbortedFilter },
	[PollingState.AbortedPage]: { ...defaultErrorProps, status: DownloadToastType.AbortedPage },
	[PollingState.Polling]: { persistent: true, status: DownloadToastType.Pending, variant: INFOBOX_VARIANT.INFO },
};

export const getDownloadToastProps = (state: DownloadToastPollingState): ToastProps => {
	const props = pollingStateLookup[state];
	const content = T.translate(`alert.${props.status}.description`);
	const heading = T.translate(`alert.${props.status}.title`);

	return { content, heading, ...props };
};
